import { useParams, Link } from 'react-router-dom';
import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import { getComicById, comics } from '@/mocks/comics';

const coverImages: Record<string, string> = {
  'comic-1': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20handsome%20male%20protagonist%20with%20glowing%20spiritual%20energy%20surrounding%20him%20modern%20city%20background%20at%20night%20dramatic%20pose%20golden%20and%20jade%20green%20color%20scheme%20clean%20simple%20background&width=1800&height=900&seq=comic-cover-01&orientation=landscape',
  'comic-2': 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%20art%20elegant%20CEO%20man%20in%20black%20suit%20and%20beautiful%20woman%20in%20white%20dress%20rose%20petals%20scattered%20romantic%20atmosphere%20pink%20cream%20color%20scheme%20clean%20simple%20background&width=1800&height=900&seq=comic-cover-02&orientation=landscape',
  'comic-3': 'https://readdy.ai/api/search-image?query=Korean%20thriller%20webtoon%20cover%20art%20detective%20figure%20in%20dark%20trench%20coat%20standing%20in%20rainy%20alley%20neon%20reflections%20mysterious%20silhouette%20deep%20teal%20and%20crimson%20color%20scheme%20clean%20simple%20background&width=1800&height=900&seq=comic-cover-03&orientation=landscape',
  'comic-4': 'https://readdy.ai/api/search-image?query=Korean%20action%20webtoon%20cover%20art%20martial%20artist%20with%20long%20sword%20dramatic%20battle%20stance%20energy%20waves%20surrounding%20fiery%20orange%20and%20gold%20color%20scheme%20clean%20simple%20background&width=1800&height=900&seq=comic-cover-04&orientation=landscape',
  'comic-5': 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20webtoon%20cover%20art%20magic%20academy%20student%20casting%20spell%20with%20magic%20circle%20floating%20books%20purple%20and%20gold%20color%20scheme%20clean%20simple%20background&width=1800&height=900&seq=comic-cover-05&orientation=landscape',
  'comic-6': 'https://readdy.ai/api/search-image?query=Korean%20comedy%20webtoon%20cover%20art%20group%20of%20high%20school%20students%20laughing%20together%20in%20classroom%20bright%20sunny%20yellow%20color%20scheme%20clean%20simple%20background&width=1800&height=900&seq=comic-cover-06&orientation=landscape',
  'comic-7': 'https://readdy.ai/api/search-image?query=Korean%20historical%20webtoon%20cover%20art%20beautiful%20woman%20in%20traditional%20hanbok%20standing%20in%20ancient%20palace%20garden%20soft%20autumn%20leaves%20golden%20beige%20color%20scheme%20clean%20simple%20background&width=1800&height=900&seq=comic-cover-07&orientation=landscape',
  'comic-8': 'https://readdy.ai/api/search-image?query=Korean%20horror%20webtoon%20cover%20art%20exorcist%20holding%20talisman%20against%20dark%20spirit%20shadow%20in%20modern%20apartment%20eerie%20green%20glow%20dark%20atmosphere%20clean%20simple%20background&width=1800&height=900&seq=comic-cover-08&orientation=landscape',
  'comic-9': 'https://readdy.ai/api/search-image?query=Korean%20healing%20webtoon%20cover%20art%20cozy%20cafe%20barista%20smiling%20behind%20counter%20steaming%20coffee%20warm%20sunlight%20through%20window%20cream%20beige%20color%20scheme%20clean%20simple%20background&width=1800&height=900&seq=comic-cover-09&orientation=landscape',
  'comic-10': 'https://readdy.ai/api/search-image?query=Korean%20drama%20webtoon%20cover%20art%20confident%20businesswoman%20in%20office%20attire%20looking%20out%20skyscraper%20window%20city%20skyline%20sunset%20warm%20muted%20teal%20color%20scheme%20clean%20simple%20background&width=1800&height=900&seq=comic-cover-10&orientation=landscape',
};

const thumbImages: Record<string, string> = {
  'comic-1': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20handsome%20male%20protagonist%20with%20glowing%20spiritual%20energy%20surrounding%20him%20modern%20city%20background%20at%20night%20dramatic%20pose%20golden%20and%20jade%20green%20color%20scheme%20clean%20simple%20background&width=200&height=280&seq=comic-cover-01&orientation=portrait',
  'comic-2': 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%20art%20elegant%20CEO%20man%20in%20black%20suit%20and%20beautiful%20woman%20in%20white%20dress%20rose%20petals%20scattered%20romantic%20atmosphere%20pink%20cream%20color%20scheme%20clean%20simple%20background&width=200&height=280&seq=comic-cover-02&orientation=portrait',
  'comic-3': 'https://readdy.ai/api/search-image?query=Korean%20thriller%20webtoon%20cover%20art%20detective%20figure%20in%20dark%20trench%20coat%20standing%20in%20rainy%20alley%20neon%20reflections%20mysterious%20silhouette%20deep%20teal%20and%20crimson%20color%20scheme%20clean%20simple%20background&width=200&height=280&seq=comic-cover-03&orientation=portrait',
  'comic-4': 'https://readdy.ai/api/search-image?query=Korean%20action%20webtoon%20cover%20art%20martial%20artist%20with%20long%20sword%20dramatic%20battle%20stance%20energy%20waves%20surrounding%20fiery%20orange%20and%20gold%20color%20scheme%20clean%20simple%20background&width=200&height=280&seq=comic-cover-04&orientation=portrait',
  'comic-5': 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20webtoon%20cover%20art%20magic%20academy%20student%20casting%20spell%20with%20magic%20circle%20floating%20books%20purple%20and%20gold%20color%20scheme%20clean%20simple%20background&width=200&height=280&seq=comic-cover-05&orientation=portrait',
  'comic-6': 'https://readdy.ai/api/search-image?query=Korean%20comedy%20webtoon%20cover%20art%20group%20of%20high%20school%20students%20laughing%20together%20in%20classroom%20bright%20sunny%20yellow%20color%20scheme%20clean%20simple%20background&width=200&height=280&seq=comic-cover-06&orientation=portrait',
  'comic-7': 'https://readdy.ai/api/search-image?query=Korean%20historical%20webtoon%20cover%20art%20beautiful%20woman%20in%20traditional%20hanbok%20standing%20in%20ancient%20palace%20garden%20soft%20autumn%20leaves%20golden%20beige%20color%20scheme%20clean%20simple%20background&width=200&height=280&seq=comic-cover-07&orientation=portrait',
  'comic-8': 'https://readdy.ai/api/search-image?query=Korean%20horror%20webtoon%20cover%20art%20exorcist%20holding%20talisman%20against%20dark%20spirit%20shadow%20in%20modern%20apartment%20eerie%20green%20glow%20dark%20atmosphere%20clean%20simple%20background&width=200&height=280&seq=comic-cover-08&orientation=portrait',
  'comic-9': 'https://readdy.ai/api/search-image?query=Korean%20healing%20webtoon%20cover%20art%20cozy%20cafe%20barista%20smiling%20behind%20counter%20steaming%20coffee%20warm%20sunlight%20through%20window%20cream%20beige%20color%20scheme%20clean%20simple%20background&width=200&height=280&seq=comic-cover-09&orientation=portrait',
  'comic-10': 'https://readdy.ai/api/search-image?query=Korean%20drama%20webtoon%20cover%20art%20confident%20businesswoman%20in%20office%20attire%20looking%20out%20skyscraper%20window%20city%20skyline%20sunset%20warm%20muted%20teal%20color%20scheme%20clean%20simple%20background&width=200&height=280&seq=comic-cover-10&orientation=portrait',
};

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const comic = id ? getComicById(id) : undefined;
  const [readChapter, setReadChapter] = useState<number | null>(null);

  if (!comic) {
    return (
      <>
        <SEO title="漫画未找到 - 韩漫之家" description="抱歉，您访问的漫画不存在。" keywords="韩漫之家" />
        <Navbar />
        <main className="pt-16 min-h-[60vh] flex items-center justify-center">
          <div className="text-center">
            <h1 className="font-heading text-3xl font-bold text-foreground-950">漫画未找到</h1>
            <Link to="/" className="mt-4 inline-block text-primary-500 hover:text-primary-600 cursor-pointer">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const relatedComics = comics.filter((c) => c.categorySlug === comic.categorySlug && c.id !== comic.id).slice(0, 3);

  const comicTitle = `${comic.title} - 免费韩漫下拉式在线阅读 - 韩漫之家`;
  const comicDesc = `韩漫之家为您提供${comic.title}免费下拉式在线阅读，${comic.description.slice(0, 80)}高清画质，每日更新。`;

  const articleLD = {
    '@context': 'https://schema.org',
    '@type': 'ComicStory',
    'name': comic.title,
    'author': { '@type': 'Person', 'name': comic.author },
    'description': comic.description,
    'url': `http://dnchemical.com/article/${comic.id}`,
    'dateModified': comic.updatedAt,
    'aggregateRating': {
      '@type': 'AggregateRating',
      'ratingValue': comic.rating,
      'bestRating': '5',
      'ratingCount': comic.reviews.length,
    },
    'interactionStatistic': {
      '@type': 'InteractionCounter',
      'interactionType': 'https://schema.org/ViewAction',
      'userInteractionCount': comic.viewCount,
    },
    'isPartOf': {
      '@type': 'WebSite',
      'name': '韩漫之家',
      'url': 'http://dnchemical.com/',
    },
  };

  const breadcrumbLD = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': [
      { '@type': 'ListItem', 'position': 1, 'name': '首页', 'item': 'http://dnchemical.com/' },
      { '@type': 'ListItem', 'position': 2, 'name': comic.category, 'item': `http://dnchemical.com/category/${comic.categorySlug}` },
      { '@type': 'ListItem', 'position': 3, 'name': comic.title, 'item': `http://dnchemical.com/article/${comic.id}` },
    ],
  };

  return (
    <>
      <SEO
        title={comicTitle}
        description={comicDesc}
        keywords={`${comic.title},${comic.category},免费韩漫,韩漫之家,韩国漫画在线阅读`}
        canonicalUrl={`http://dnchemical.com/article/${comic.id}`}
      />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(articleLD) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbLD) }} />
      <Navbar />
      <main>
        <section className="relative pt-16">
          <div className="relative h-[420px] md:h-[560px] overflow-hidden">
            <div className="absolute inset-0">
              <img
                src={coverImages[comic.id]}
                alt={comic.title}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70"></div>
            </div>
            <div className="relative z-10 h-full flex items-end">
              <div className="max-w-7xl mx-auto px-4 md:px-6 w-full pb-12">
                <nav className="flex items-center gap-2 text-xs text-background-50/60 mb-4 flex-wrap" aria-label="breadcrumb">
                  <Link to="/" className="hover:text-background-50 transition-colors cursor-pointer">首页</Link>
                  <span>/</span>
                  <Link to={`/category/${comic.categorySlug}`} className="hover:text-background-50 transition-colors cursor-pointer">{comic.category}</Link>
                  <span>/</span>
                  <span className="text-background-50/80">{comic.title}</span>
                </nav>
                <div className="flex flex-col md:flex-row md:items-end gap-6">
                  <div className="w-28 md:w-36 shrink-0 rounded-lg overflow-hidden ring-2 ring-background-50/20">
                    <img
                      src={thumbImages[comic.id]}
                      alt={comic.title}
                      className="w-full aspect-[3/4] object-cover object-top"
                    />
                  </div>
                  <div className="flex-1">
                    <h1 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-tight">
                      {comic.title}
                    </h1>
                    <div className="mt-3 flex flex-wrap items-center gap-3 text-sm text-background-50/70">
                      <span>作者：{comic.author}</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-star-fill text-accent-400"></i> {comic.rating}
                      </span>
                      <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                        comic.status === '连载中' ? 'bg-accent-500 text-background-50' : 'bg-secondary-500 text-background-50'
                      }`}>
                        {comic.status}
                      </span>
                      <span>{comic.viewCount.toLocaleString()} 次阅读</span>
                      <span>{comic.favoriteCount.toLocaleString()} 收藏</span>
                    </div>
                    <div className="mt-3 flex flex-wrap gap-2">
                      {comic.tags.map((tag) => (
                        <span key={tag} className="inline-block px-2.5 py-0.5 rounded-full bg-background-50/15 text-background-50 text-xs whitespace-nowrap">
                          {tag}
                        </span>
                      ))}
                    </div>
                    <div className="mt-4 flex flex-wrap gap-3">
                      <button
                        onClick={() => setReadChapter(comic.chapters[0].number)}
                        className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
                      >
                        开始阅读
                      </button>
                      <button className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-background-50/30 text-background-50 font-medium text-sm hover:bg-background-50 hover:text-foreground-950 transition-all duration-300 whitespace-nowrap cursor-pointer">
                        <span className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-bookmark-line"></i>
                        </span>
                        加入书架
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
              <div className="lg:col-span-2">
                <div className="bg-background-100 rounded-lg p-6 md:p-8">
                  <h2 className="font-heading text-xl font-bold text-foreground-950 mb-4">作品简介</h2>
                  <p className="text-sm text-foreground-600 leading-relaxed">{comic.description}</p>
                </div>

                <div className="mt-10">
                  <h2 className="font-heading text-xl font-bold text-foreground-950 mb-6">章节列表</h2>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {comic.chapters.map((ch) => (
                      <button
                        key={ch.id}
                        onClick={() => setReadChapter(ch.number)}
                        className="flex items-center justify-between p-4 rounded-lg bg-background-100 hover:bg-background-200 transition-colors text-left cursor-pointer"
                      >
                        <div>
                          <span className="text-sm font-medium text-foreground-900">{ch.title}</span>
                          <span className="block text-xs text-foreground-400 mt-1">{ch.updatedAt}</span>
                        </div>
                        <div className="flex items-center gap-2 text-xs text-foreground-400">
                          <span>{ch.viewCount.toLocaleString()} 阅读</span>
                          <span className="w-4 h-4 flex items-center justify-center">
                            <i className="ri-arrow-right-s-line"></i>
                          </span>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              <div>
                <div className="bg-background-100 rounded-lg p-6 sticky top-24">
                  <h3 className="font-heading text-lg font-bold text-foreground-950 mb-4">同类推荐</h3>
                  <div className="flex flex-col gap-4">
                    {relatedComics.map((rc) => (
                      <Link
                        key={rc.id}
                        to={`/article/${rc.id}`}
                        className="flex gap-3 group cursor-pointer"
                      >
                        <div className="w-16 h-20 shrink-0 rounded-md overflow-hidden">
                          <img
                            src={thumbImages[rc.id]}
                            alt={rc.title}
                            className="w-full h-full object-cover object-top"
                          />
                        </div>
                        <div className="flex-1 min-w-0">
                          <h4 className="text-sm font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors">
                            {rc.title}
                          </h4>
                          <div className="mt-1 flex items-center gap-2 text-xs text-foreground-400">
                            <span className="flex items-center gap-0.5">
                              <i className="ri-star-fill text-accent-400 text-xs"></i> {rc.rating}
                            </span>
                            <span>{rc.status}</span>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {comic.reviews.length > 0 && (
          <section className="py-12 md:py-16 bg-background-100">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="text-center mb-10">
                <div className="inline-flex items-center gap-2 mb-2">
                  <span className="w-5 h-5 flex items-center justify-center bg-accent-100 rounded">
                    <i className="ri-chat-3-line text-accent-500 text-xs"></i>
                  </span>
                  <span className="text-xs font-medium text-accent-600">漫友评论</span>
                </div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">读者评价</h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
                {comic.reviews.map((review) => (
                  <div key={review.id} className="p-5 rounded-lg bg-background-50">
                    <div className="flex items-center gap-3 mb-3">
                      <img src={review.avatar} alt={review.userName} className="w-9 h-9 rounded-full object-cover" />
                      <div>
                        <div className="text-sm font-semibold text-foreground-900">{review.userName}</div>
                        <div className="text-xs text-foreground-400">{review.date}</div>
                      </div>
                    </div>
                    <div className="flex gap-0.5 mb-2">
                      {Array.from({ length: review.rating }).map((_, j) => (
                        <span key={j} className="w-3 h-3 flex items-center justify-center">
                          <i className="ri-star-fill text-accent-400 text-xs"></i>
                        </span>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">{review.content}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}

        <section className="relative py-20 md:py-28 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20beautiful%20bookshelf%20filled%20with%20colorful%20comics%20warm%20reading%20nook%20cozy%20armchair%20soft%20lamp%20light%20golden%20hour%20atmosphere%20inviting%20warm%20tones%20manhwa%20art%20style&width=1800&height=800&seq=cta-article&orientation=landscape"
              alt="韩漫之家 - 加入书架"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-black/45"></div>
          </div>
          <div className="relative z-10 max-w-2xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50">加入书架随时追更</h2>
            <p className="mt-3 text-sm md:text-base text-background-50/70">收藏喜欢的漫画，不错过每一次更新</p>
            <button className="mt-6 inline-flex items-center gap-2 px-8 py-3 rounded-full bg-accent-500 text-background-50 font-medium text-sm hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-bookmark-fill"></i>
              </span>
              加入书架
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line"></i>
              </span>
            </button>
          </div>
        </section>

        {readChapter && (
          <div className="fixed inset-0 z-50 bg-background-50 overflow-y-auto">
            <div className="sticky top-0 bg-background-50 border-b border-background-200 px-4 py-3 flex items-center justify-between z-10">
              <button
                onClick={() => setReadChapter(null)}
                className="flex items-center gap-1 text-sm text-foreground-600 hover:text-foreground-900 cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-left-line"></i>
                </span>
                返回
              </button>
              <span className="text-sm font-medium text-foreground-900">第{readChapter}章</span>
              <span className="text-xs text-foreground-400">下拉式阅读</span>
            </div>
            <div className="max-w-2xl mx-auto px-4 py-8">
              <div className="space-y-8">
                {Array.from({ length: 8 }).map((_, i) => (
                  <div key={i} className="rounded-lg overflow-hidden bg-background-100">
                    <div className="aspect-[3/4] bg-secondary-100 flex items-center justify-center">
                      <div className="text-center">
                        <span className="w-12 h-12 flex items-center justify-center mx-auto">
                          <i className="ri-image-line text-foreground-300 text-2xl"></i>
                        </span>
                        <p className="text-sm text-foreground-400 mt-2">漫画内容 · 第{i + 1}页</p>
                        <p className="text-xs text-foreground-300 mt-1">下拉式在线阅读体验</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-8 flex items-center justify-between">
                <button className="px-5 py-2.5 rounded-full bg-background-100 text-foreground-700 text-sm hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer">
                  上一章
                </button>
                <button className="px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                  下一章
                </button>
              </div>
            </div>
          </div>
        )}
      </main>
      <Footer />
    </>
  );
}